import DashboardModuleBaseArea from '@/modules/dashboard-module/shared/components/base-area/dashboard-module-shared-components-base-area.vue'
import { DashboardViewsUtilitiesAreaViewsAreaState, initialDashboardViewsUtilitiesAreaViewsAreaState } from '@/modules/dashboard-module/views/utilities-area/dashboard-views-utilities-area.model'
import { Vue, Component } from 'vue-property-decorator'

@Component({
    components: {
        DashboardModuleBaseArea
    }
})
export default class DashboardViewsUtilitiesArea extends Vue {
    state: DashboardViewsUtilitiesAreaViewsAreaState
    constructor() {
        super()
        this.state = initialDashboardViewsUtilitiesAreaViewsAreaState()
    }
}
